import { VideoSizesHandlerStrategy } from './video-sizes-handler-strategy';
import { IN_ARTICLE_LANDSCAPE } from '../../../enums/in-article';
import { compareNb } from '../../../../../common/js/utils';
import { AnalyticsStore } from '../../../../../common/js/stores/analytics.store';
import { IVideoSizes } from '../../../../../common/js/video-utils';
import { VideoStore } from '../../../../../common/js/stores/video.store';
import { hasSkin } from '../../utils';
import { ConfigStore } from '../../../../../common/js/stores/config.store';

const RATIO_VERTICAL = 9 / 16;
const RATIO_HORIZONTAL = 16 / 9;
const RATIO_SQUARE = 1;
const RATIO_FOUR_THREEE = 4 / 3;

interface AdContext {
  inArticleType?: string;
  [key: string]: any;
}

export class InArticleVideoSizesHandlerStrategy extends VideoSizesHandlerStrategy {
  adContext: AdContext;
  configStore: ConfigStore;

  constructor(videoStore: VideoStore, analyticsStore: AnalyticsStore) {
    super(analyticsStore);

    this.configStore = videoStore.configStore;
    this.adContext = videoStore.adContext;
  }

  reactToSizes(videoSizes: IVideoSizes): void {
    super.reactToSizes(videoSizes);

    if (!videoSizes.video_height || !videoSizes.video_width) {
      return;
    }

    const { inArticleType } = this.adContext;
    const actualRatio = videoSizes.video_width / videoSizes.video_height;

    if (hasSkin(this.configStore.config)) {
      return;
    }

    const expectedRatios =
      inArticleType === IN_ARTICLE_LANDSCAPE
        ? [RATIO_HORIZONTAL, RATIO_SQUARE, RATIO_FOUR_THREEE]
        : [RATIO_VERTICAL];

    const hasAtleastOneOfExpectedRatio = expectedRatios.some(expectedRatio => {
      if (compareNb(expectedRatio, actualRatio)) {
        return true;
      }
      return false;
    });

    if (!hasAtleastOneOfExpectedRatio) {
      this.analyticsStore.sendEvent('monitoring', 'unexpected_creative_ratio');
    }
  }
}
